import SelectionState from "state/selections/SelectionState";
import { selectDefinitions } from "./selectors";
import { useDispatch, useSelector } from "react-redux";
import { useMemo } from "react";
import { useQuery } from "react-query";
import {
  selectCommittedAsOfDateEntity,

} from "state/selections/selector";
import { setDefinition } from "./actions";
import { commitSelections } from "state/selections/actions";
import scope from "./scope";
import { useIsFetching } from "react-query";
import { format } from "date-fns";

export const useColumnDefinitions = () => {
  const definition = useSelector(
    selectDefinitions(SelectionState.COMMITTED)
  )?.[0];
  const dispatch = useDispatch();
  const isFetching = useIsFetching([scope]);
  return useMemo(() => {
    const columnDefs = [];
    if (definition?.clientLossRstr) {
      columnDefs.push({
        headerName: "Client Loss Restrictions",
        colId: "lossRestriction",
        field: "lossRestriction",
        loading: isFetching,
        X_formatType: "TEXT",
        minWidth: 400,
        width: 100,
        tooltipField: 'lossRestriction',
        cellStyle: {
          'white-space': 'break-spaces'
        },
        X_onDelete: () => {
          dispatch(setDefinition(0, definition.setClientLossRstr(false), true));
          dispatch(commitSelections());
        },
      });
    }
    return columnDefs;
  }, [definition, isFetching, dispatch]);
};

export const useRowsMap = () => {
  const dataQuery = useDataQuery();
  const { data } = dataQuery;
  return useMemo(() => {
    const { data: lossRtr } = data ?? [];
    const map = {};
    lossRtr?.forEach((row) => {
      if (!map[row.entityId]) {
        map[row.entityId] = {};
      }
      map[row.entityId].lossRestriction = row.lossRestriction;
    });
    return map;
  }, [data]);
};
export const useDataQuery = () => {
  const definition = useSelector(
    selectDefinitions(SelectionState.COMMITTED)
  )?.[0];

  const asOfDateEntity = useSelector(selectCommittedAsOfDateEntity);
  return useQuery({
    enabled: !!definition,
    queryKey: [
      scope,
      definition?.clientLossRstr
    ],
    queryFn: async () => {
      const params = {
        asOfDate: format(asOfDateEntity, "MM/dd/yyyy"),

      };

      const fetchClientLossRstr = async () => {

        const url = new URL(
          `${process.env.REACT_APP_BASE_URL_CLIENTLOSSRSTR_SERVICE}/cis`
        );
        url.search = new URLSearchParams({
          ...params

        }).toString();
        const res = await fetch(url);
        return await res.json();

      };


      return await fetchClientLossRstr();
    },
  });
};
